import React from "react";
import { motion } from "framer-motion";
import { MapPin, Gift, ArrowUpRight } from "lucide-react";

const WISHLIST_URL =
    "https://www.amazon.com/hz/wishlist/ls/M9BNEE53W3YP?ref_=wl_share";

const Card = ({ children, ...props }) => (
    <motion.div
        whileHover={{ y: -8 }}
        transition={{ type: "spring", stiffness: 260, damping: 18 }}
        {...props}
    >
        {children}
    </motion.div>
);

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const BentoNav = () => {
    return (
        <section className="relative py-20 sm:py-28 px-6">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                    <span className="inline-block font-heading uppercase tracking-widest text-xs sm:text-sm bg-accent text-accent-foreground rounded-full px-5 py-2">
                        Navegação rápida
                    </span>
                    <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mt-6">
                        Tudo o que você precisa saber
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
                    <Card
                        data-testid="bento-event-details"
                        onClick={() => scrollTo("event-details")}
                        role="button"
                        tabIndex={0}
                        className="cursor-pointer bg-white border-thick shadow-pop rounded-3xl p-8 flex flex-col justify-between min-h-[260px]"
                    >
                        <div>
                            <MapPin className="w-10 h-10" strokeWidth={2.5} />
                            <h3 className="font-heading text-2xl sm:text-3xl font-bold mt-6">
                                Detalhes do Evento
                            </h3>
                            <p className="mt-3 text-foreground/70">
                                Local, horário, e tudo o que você precisa para
                                chegar pontualmente à festa.
                            </p>
                        </div>
                        <span className="mt-6 inline-flex items-center gap-2 font-heading text-sm uppercase tracking-widest">
                            Ver detalhes <ArrowUpRight className="w-4 h-4" />
                        </span>
                    </Card>

                    <Card
                        data-testid="bento-gift-list"
                        className="cursor-pointer bg-secondary text-secondary-foreground border-thick shadow-pop rounded-3xl p-8 flex flex-col justify-between min-h-[260px]"
                        onClick={() => window.open(WISHLIST_URL, "_blank", "noopener")}
                        role="button"
                        tabIndex={0}
                    >
                        <div>
                            <Gift className="w-10 h-10" strokeWidth={2.5} />
                            <h3 className="font-heading text-2xl sm:text-3xl font-bold mt-6">
                                Lista de Presentes
                            </h3>
                            <p className="mt-3 text-foreground/80">
                                Veja sugestões de presentes que o Christopher
                                vai adorar — direto na Amazon.
                            </p>
                        </div>
                        <a
                            href={WISHLIST_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="amazon-wishlist-link"
                            onClick={(e) => e.stopPropagation()}
                            className="mt-6 inline-flex items-center gap-2 font-heading text-sm uppercase tracking-widest underline underline-offset-4"
                        >
                            Abrir Lista Amazon <ArrowUpRight className="w-4 h-4" />
                        </a>
                    </Card>
                </div>
            </div>
        </section>
    );
};

export default BentoNav;
